<template>
    <form novalidate class="md-layout" v-if="!loading">
        <md-content class=" md-layout-item md-size-100 md-small-size-100">
            <div class="md-flex-center-center md-form-input md-relative">
                <h1 class="md-title md-form-title">{{ $t('views.main.links.add-order') }}</h1>
                <md-card class="md-form-card md-mt-70 cardBox">
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('spotTypeId')">
                                <label for="spotType">{{ $t('views.order.radio.form.label.spotType') }}</label>
                                <SelectWithFilter @mdselect="setDefaultSpotType()" :list="spotTypes" v-model="$v.form.spotTypeId.$model"
                                    :name="`spotType`" :id="`spotType`" :disabled="sending" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error"
                                      v-if="!$v.form.spotTypeId.required">{{ $t('validation.required') }}</span>
                                <server-error v-else field-name="spotTypeId" :server-errors="serverErrors" />
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('packageTypeId')">
                                <label for="packageType">{{ $t('views.order.radio.form.label.packageType') }}</label>
                                <SelectWithFilter @mdselect="onPackageTypeChange(true)" :list="packageTypes" v-model="$v.form.packageTypeId.$model"
                                    :name="`packageType`" :id="`packageType`" :disabled="!form.spotTypeId || sending" v-slot="{item}">
                                    <md-option :value="item.packageType.valueId">{{ item.packageType.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.packageTypeId.required">{{ $t('validation.required') }}</span>
                                <server-error v-else field-name="packageTypeId" :server-errors="serverErrors" />
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('grpSaleTypeId')">
                                <label for="grpSaleType">{{ $t('views.order.radio.form.label.grpSaleType') }}</label>
                                <SelectWithFilter @mdselect="onSaleTypeChange" :list="form.packageTypeId ? saleTypes : []" @input="setPriceMethod()" v-model="$v.form.grpSaleTypeId.$model"
                                    :name="`grpSaleType`" :id="`grpSaleType`" :disabled="!form.packageTypeId || sending" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.grpSaleTypeId.required">{{ $t('validation.required') }}</span>
                                <server-error v-else field-name="grpSaleTypeId" :server-errors="serverErrors" />
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('priceMethod')">
                                <label for="priceMethod">{{ !form.grpSaleTypeId ? `${$t('views.order.tv.form.label.grp')}/${$t('views.order.tv.form.label.budget')}` : $t('views.order.radio.form.label.priceMethod') }}</label>
                                <SelectWithFilter @mdselect="save(true)" :list="form.packageTypeId ? getPriceMethods(allowGrp) : []" @input="clearOrderMethod()" v-model="$v.form.priceMethod.$model"
                                    :name="`priceMethod`" :id="`priceMethod`" :disabled="!form.packageTypeId || sending" v-slot="{item}">
                                    <md-option :value="!form.grpSaleTypeId ? '' : item.name ">{{ $t(`views.order.radio.form.label.${item.name}`) }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.priceMethod.required">{{ $t('validation.required') }}</span>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100"
                             v-if="getPriceMethodUnit(form.priceMethod) === 'GRP'">
                            <md-field :class="getValidationClass('grp')">
                                <label for="grp">{{ !form.packageTypeId ? `${$t('views.order.radio.form.label.grp')}/${$t('views.order.radio.form.label.budget')}` : $t('views.order.radio.form.label.grp') }}</label>
                                <md-input name="grp" id="grp"
                                          :value="formatLocaleNumber($v.form.grp.$model)"
                                          @input="setValue(getParsedLocaleNumberOrInputString($event), '$v.form.grp.$model')"
                                          autocomplete="off"
                                          :disabled="!form.packageTypeId || sending" required @blur="save(true)" />
                                <span class="md-suffix">{{ !form.packageTypeId ? null : 'GRP' }}</span>
                                <span class="md-error" v-if="!$v.form.grp.required">{{ $t('validation.required') }}</span>
                                <span class="md-error" v-else-if="!$v.form.grp.greaterThan">{{ $t('validation.greaterThan', {0: $v.form.grp.$params.greaterThan.value}) }}</span>
                                <span class="md-error" v-else-if="!$v.form.grp.decimal">
                                   {{
                                        $t('validation.decimalWithPoint', {
                                            decimalPlaces: $v.form.grp.$params.decimal.decimalPlaces
                                        })
                                    }}
                                </span>
                                <server-error v-else field-name="grp" :server-errors="serverErrors" />
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100"
                             v-if="getPriceMethodUnit(form.priceMethod) === 'PLN'">
                            <md-field :class="getValidationClass('budget')">
                                <label for="budget">{{ !form.packageTypeId ? `${$t('views.order.radio.form.label.grp')}/${$t('views.order.radio.form.label.budget')}` : $t('views.order.radio.form.label.budget') }}</label>
                                <md-input name="budget" id="budget"
                                          :value="formatLocaleNumber($v.form.budget.$model)"
                                          @input="setValue(getParsedLocaleNumberOrInputString($event), '$v.form.budget.$model')"
                                          autocomplete="off"
                                          :disabled="!form.packageTypeId || sending" required @blur="save(true)" />
                                <span class="md-suffix">{{ !form.packageTypeId ? null : 'PLN' }}</span>
                                <span class="md-error" v-if="!$v.form.budget.required">{{ $t('validation.required') }}</span>
                                <span class="md-error" v-else-if="!$v.form.budget.greaterThan">{{ $t('validation.greaterThan', {0: $v.form.budget.$params.greaterThan.value}) }}</span>
                                <span class="md-error" v-else-if="!$v.form.budget.decimal">
                                   {{
                                        $t('validation.decimalWithPoint', {
                                            decimalPlaces: $v.form.budget.$params.decimal.decimalPlaces
                                        })
                                    }}
                                </span>
                                <server-error v-else field-name="budget" :server-errors="serverErrors" />
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout">
                        <div class="md-layout-item md-layout md-size-100" v-if="includeJoinInvoices">
                            <md-checkbox v-model="$v.form.joinInvoices.$model" @change="save(true)">
                        {{ $t('views.order.campaign.form.label.groupOrder') }}  
                        <md-tooltip md-direction="right">{{ $t('views.order.campaign.form.label.groupOrderInfo') }}</md-tooltip>   
                        </md-checkbox>
                       </div>
                    </div>
                    <order-stations-table :add-station-handler="addStation" :allow-add-station="allowAddStation" :package-type-id="form.packageTypeId"
                                          :campaign-id="common.id" :order-id="form.id" v-model="orderStationsList"
                                          :validator="$v.orderStationsList" :allow-edit="allowAddStation" :draft="true"
                                          :loading="orderStationsLoading" v-if="orderStationsList.length > 0 || allowAddStation" />

                    <order-products-table :add-product-handler="addProduct" :campaign-id="common.id" :order-id="form.id"
                                          :validator="$v.orderProducts" v-model="orderProducts" :allow-edit="true" :draft="true" />

                    <order-product-sequence v-model="orderProductsSequences" class="md-mt-30" :order-products="orderProducts"
                                            :order-id="form.id" :allow-edit="true" :draft="true" />

                    <order-attachments-table :add-attachment-handler="addAttachment" :campaign-id="common.id" :order-id="form.id" v-model="orderAttachments" />

                    <div class="md-layout-item md-size-100 md-flex-right-align md-mt-30">
                        <md-button class="md-form-btn-cancel" @click="cancel">{{ $t('views.order.radio.buttons.cancel') }}</md-button>
                        <md-button class="md-subtitle-btn md-order-next-button" @click="routeToSummary()">{{ $t('views.order.tv.buttons.next') }}</md-button>
                    </div>
                </md-card>
            </div>
        </md-content>
    </form>
</template>

<script>
import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
import ServerError from '@/components/ServerError';
import {agenciesEndpoint} from '@/services/adsign-backend/endpoints';
import OrderProductSequence from '@/views/order/product/OrderProductSequence';
import OrderProductsTable from '@/views/order/OrderProductsTable';
import OrderStationsTable from '@/views/order/OrderStationsTable';
import OrderAttachmentsTable from '@/views/order/OrderAttachmentsTable'
import orderCommons from '@/mixins/orderCommons';
import SelectWithFilter from '@/components/SelectWithFilter'
import {PackageTypeShortName, SaleTypeShortName} from '@/mixins/dictionariesConst';
import store from '@/store'

export default {
    name: 'OrderRadioForm',
    components: {OrderStationsTable, OrderProductsTable, OrderProductSequence, ServerError, SelectWithFilter, OrderAttachmentsTable},
    mixins: [serverSideValidationErrors, orderCommons],
    props: {
        value: {
            type: Object,
            required: true
        },
        common: {
            type: Object,
            required: true
        },
        orderNo: {
            type: [Number, String],
            required: true
        },
        dictionaries: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            loading: true,
            sending: false,
            condition: null,
            packageTypes: {},
            spotTypes: {},
            allowGrp: null,
            form: {
                id: this.value?.id,
                no: this.value?.no,
                orderType: {
                    shortName: 'Radio',
                },
                orderTypeId: this.value?.orderTypeId,
                spotTypeId: this.value?.spotTypeId,
                priceMethod: this.value?.priceMethod || this.getDefaultPriceMethodName(),
                budget: this.value?.budget,
                grp: this.value?.grp,
                grpSaleTypeId: this.value?.grpSaleTypeId || this.dictionaries.grpSaleTypes.find(item => item.shortName == SaleTypeShortName.Cennik)?.valueId,
                packageTypeId: this.value?.packageTypeId,
                joinInvoices: this.value?.joinInvoices || false
            },
            orderStations: this.value?.orderStations || [],
            orderStationsLoading: false,
            orderAttachments: this.value?.orderAttachments || [],
            orderProducts: this.value?.orderProducts || [],
            orderProductsSequences: this.value?.orderProductsSequences || [],
            priceMethodsFilter: {
                cennik: (item) => item.name === 'budget',
                spotowe: (item) => item.name === 'budget'
            }
        }
    },
    computed: {
        saleTypes() {
            return this.dictionaries.grpSaleTypes.filter(item => item.shortName == SaleTypeShortName.Cennik)
        }
    },
    methods: {
        setDefaultSpotType(){
          this.loadConditions(true);
          this.onPackageTypeChange(true)
        },
        routeToSummary() {
            const orderId = this.common.id
            this.$router.push(`/campaign/${orderId}/summary`)
        },
        setPriceMethod(){
            this.form.priceMethod = this.getDefaultPriceMethodName();
        },
        getDefaultPriceMethodName() {
            return 'budget';
        },
        clearOrderMethod() {
            if (this.form.priceMethod === 'budget') {
                this.form.grp = ''
            }
            if (this.form.priceMethod === 'grp') {
                this.form.budget = ''
            }
        }
    },
    mounted(){
        this.$watch(() => this.spotTypes, newValue => {
            if(newValue.length === 0){
                store.commit('snackbar/SNACKBAR_TITLE', this.$t(`error.code.spotTypeIsEmpty`))
                store.commit('snackbar/SNACKBAR_SHOW', true)
            } else if(newValue.length > 0) {
                this.$v.form.spotTypeId.$model = newValue[0].valueId;
            }
        })
        this.$watch(() => this.packageTypes, newValue => {
            if(!newValue){
                store.commit('snackbar/SNACKBAR_TITLE', this.$t(`error.code.packageTypeIsEmpty`))
                store.commit('snackbar/SNACKBAR_SHOW', true)
            }
        })
        this.$watch(() => this.form.packageTypeId, newValue => {
            if( newValue && this.saleTypes.length === 0){
                store.commit('snackbar/SNACKBAR_TITLE', this.$t(`error.code.grpSaleTypesIsEmpty`))
                store.commit('snackbar/SNACKBAR_SHOW', true)
            }
        })

        agenciesEndpoint.getAgencyAllowGrp(this.common.agencyId).then(result => {
            this.allowGrp = result.data;
        });

    }
}
</script>

<style scoped lang="scss">
    ::v-deep {
        #grp {
            height: 45px;
        }
        #budget {
           height: 45px;
       }
    }

    .cardBox{
        margin-bottom: 20px;
    }
</style>

